/* eslint-disable */
/* eslint-disable react/prop-types */
/* eslint-disable quotes */
import React, { useMemo, useState } from 'react';
import { MaterialReactTable, useMaterialReactTable, MRT_GlobalFilterTextField, MRT_ToggleFiltersButton } from 'material-react-table';
import { Box, Button, Dialog } from '@mui/material';
import { FileDownload } from '@mui/icons-material';
import FormComponent from './FormComponent';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const Material_React_Table = ({ data = [], columns = [], onRowAdd, onRowUpdate, onRowDelete, userInitialState }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState(""); // 'add' or 'edit'
  const [selectedRow, setSelectedRow] = useState(null);

  const handleOpenModal = (type, rowData = null) => {
    setModalType(type);
    setSelectedRow(rowData);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedRow(null);
  };

  const handleFormSubmit = (values) => {
    if (modalType === "add") onRowAdd(values);
    else if (modalType === "edit") onRowUpdate(values);
    handleCloseModal();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const tableColumn = columns.map(col => col.header || col.accessorKey);
    const tableRows = data.map(row => columns.map(col => row[col.accessorKey]));
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
    });
    doc.save("TableData.pdf");
  };

  const table = useMaterialReactTable({
    columns: useMemo(() => columns, [columns]),
    data: useMemo(() => data, [data]),
    enableColumnFilterModes: true,
    enableColumnOrdering: true,
    enableGrouping: true,
    enableEditing: false,
    editingMode: 'row',
    enableColumnPinning: true,
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: true,
    initialState: {
      showColumnFilters: true,
      showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
      ...userInitialState,
    },
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: { size: 'small', variant: 'outlined' },
    muiPaginationProps: { color: 'secondary', rowsPerPageOptions: [10, 20, 30], shape: 'rounded', variant: 'outlined' },
    renderTopToolbar: ({ table }) => (
      <Box sx={(theme) => ({
        backgroundColor: theme.palette.mode === 'light' ? '#f7f7f7' : '#222',
        display: 'flex',
        gap: '0.5rem',
        p: '8px',
        justifyContent: 'space-between',
      })}>
        <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <MRT_GlobalFilterTextField table={table} />
          <MRT_ToggleFiltersButton table={table} />
        </Box>
        <Box sx={{ display: 'flex', gap: '0.5rem' }}>
          <Button variant="contained" color="error" onClick={exportToPDF} startIcon={<FileDownload />}>
            Export PDF
          </Button>
        </Box>
      </Box>
    ),
  });

  return (
    <>
      <MaterialReactTable table={table} />
      <Dialog open={isModalOpen} onClose={handleCloseModal} fullWidth maxWidth="sm">
        {isModalOpen && (
          <FormComponent
            modalType={modalType}
            onClose={handleCloseModal}
            onSubmit={handleFormSubmit}
            data={selectedRow}
            columns={columns}
          />
        )}
      </Dialog>
    </>
  );
};

export default Material_React_Table;
